<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: 组件名
 * @Description: 组件描述
 * @FilePath: \web_manage_globalf:\work\web\app-tikfriend_web\src\App.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-08-11 15:28:17
 * @LastEditors: syl
 * @LastEditTime: 2022-07-04 13:34:43
 * @example: 调用示例
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
// import VConsole from 'vconsole'
import Vue from "vue"
export default {
  name: "App",
  created() {
    this.currentPlamt();
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
    ) {
      localStorage.setItem("curEquip", "m");
    } else {
      localStorage.setItem("curEquip", "pc");
    }
  },
  methods: {
    currentPlamt() {
      var hrefStr = window.location.href;
      let paramStr = "";
      if (hrefStr.indexOf("?")) {
        paramStr = hrefStr.split("=")[1];
      }
      var u = navigator.userAgent;
  //     const vConsole = new VConsole();
  //     Vue.use(vConsole);
  //     console.log("navigatorpanltform",navigator.platform,this.isMobile());
  // console.log("userAgent",navigator.userAgent);
      localStorage.setItem("systemIs64", this.isMobile());
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
      var isiOS =
        !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ||
        /(iPhone|iPad|iPod|iOS)/i.test(u) ||
        paramStr == "apple"; // ios终端
      var issafariBrowser =
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent); // 是否是safari浏览器打开
      if (isAndroid) {
        return localStorage.setItem("curSystem", "Android");
      } else if (isiOS) {
        return localStorage.setItem("curSystem", "iOS");
      } else if (issafariBrowser) {
        return localStorage.setItem("curSystem", "iOS");
      } else {
        return localStorage.setItem("curSystem", "other");
      }
    },
    isMobile() {
      // return /(iPhone|iPad|iPod|iOS|Android|Linux armv8l|Linux armv7l|Linux aarch64)/i.test(navigator.platform);
      return /(arm64|aarch64)/i.test(navigator.platform);
    }
  },
};
</script>

<style lang="scss">
#app {
  font-family: PingFangSC-Semibold, PingFang SC, "Avenir", Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #e2e4e7;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
